export default "<p-progressSpinner class=\"align\"></p-progressSpinner>\n";